import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { getHomeRoute } from 'src/app/utils/routing/routing';
import { ToastrService } from 'ngx-toastr';
import { Permissions } from 'src/app/utils/permissions/permissions';
import { Subscription } from 'rxjs';
import { PermissionsService, UsersService } from 'src/app/services/firestore';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { LoginInfo } from 'src/app/services/types/login.types';
import { LoginMethod } from 'src/app/services/types/login.enum';
import { AUTH_USE_AUTH0 } from '../auth-use-auth0.injection-token';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnDestroy, OnInit {
  mode = 'login';

  loginForm = this.fb.group({
    email: [null, [Validators.required]],
    password: [null, [Validators.required]],
  });

  loading = false;

  userSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private router: Router,
    private permissionsService: PermissionsService,
    private usersService: UsersService,
    private toaster: ToastrService,
    private fb: UntypedFormBuilder,
    private auth0Service: Auth0Service,
    @Inject(AUTH_USE_AUTH0) public readonly useAuth0: boolean,
  ) {}

  //
  // Control Block for Login type routing
  // Password Reset is not wired in the service and method is disabled but ready.
  //
  formSubmit() {
    switch (this.mode) {
      case 'login':
        return this.login();
      case 'passwordReset':
        return this.passwordReset();
    }
  }

  loginWithCredencials(credentials: LoginInfo) {
    this.loading = true;
    this.authService
      .login(credentials)
      .then(authenticationResponse => {
        this.userSubscription = this.usersService.getUserById(authenticationResponse.user.uid).subscribe(
          async user => {
            try {
              const isAdmin = await this.authService.hasPermission(Permissions.IS_ADMIN);
              const homeRoute = user && isAdmin ? '/admin' : await getHomeRoute(this.authService, this.permissionsService);

              this.router.navigate([homeRoute]);
            } catch (e) {
              this.router.navigate(['/portal/unauthorized']);
            }
          },
          err => {
            this.loading = false;
            this.toaster.error(err);
          },
        );
      })
      .catch(err => {
        this.loading = false;
        this.toaster.error(err);
      });
  }

  login() {
    if (this.loginForm.valid) {
      this.loginWithCredencials({
        method: LoginMethod.LOGIN_WITH_USER_PASSWORD,
        user: this.loginForm.value.email,
        password: this.loginForm.value.password,
      });
    }
  }

  passwordReset() {
    // const email = this.resetForm.value.email;
    // this.authService..passwordReset(email).then(res => {
    //   if (res === true) {
    //     this.toaster.info('A reset email has been sent.');
    //   } else {
    //     this.toaster.error('There was an error sending you a reset email, please confirm email is correct');
    //   }
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    try {
      if (this.useAuth0) {
        console.log('Should not be using firebase');
        this.auth0Service.isAuthenticated$.subscribe(
          isAuthenticated => {
            if (isAuthenticated) {
              console.log('It is authenticated, get token!');
              this.auth0Service.getAccessTokenSilently({ detailedResponse: true }).subscribe(token => {
                this.loginWithCredencials({
                  method: LoginMethod.LOGIN_WITH_CUSTOM_TOKEN,
                  auth0Token: token.id_token,
                });
              });
            } else {
              console.log('It is not authenticated..');
              this.auth0Service.loginWithRedirect();
            }
          },
          error => {
            console.log(error);
          },
        );
      }
    } catch (e) {
      console.log(e);
    }
  }
}
